import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Claim } from '@cms-max/medicare-api-sdk'
import { ClaimDetailsField } from './ClaimDetailsField'

export interface ClaimPaymentSummaryProps {
  claim:Claim|undefined
}

export const ClaimPaymentSummary: FC<ClaimPaymentSummaryProps> = ({ claim }) => {
  const { t } = useTranslation('claimsSearch', { keyPrefix: 'claimDetails' })

  return (
    <>
      <h2 className='ds-text-heading--2xl ds-u-margin-y--0'>
        {t('payment.claimDetailsPaymentSubheading')}
      </h2>
      <div className='m-c-card ds-u-padding--3 ds-u-margin-top--2'>
        <div className='ds-l-row'>
          <div className='ds-l-col'>
            {claim?.paymentSummary.totalAmountCharged && (
              <ClaimDetailsField
                label={t('payment.totalAmountCharged')}
                value={claim.paymentSummary.totalAmountCharged}
              />
            )}
            {claim?.paymentSummary.totalNonCoveredCharges && (
              <ClaimDetailsField
                label={t('payment.totalNonCoveredCharges')}
                value={claim.paymentSummary.totalNonCoveredCharges}
              />
            )}
            {claim?.paymentSummary.medicareApproved && (
              <ClaimDetailsField
                label={t('payment.medicareApproved')}
                value={claim.paymentSummary.medicareApproved}
              />
            )}
            {claim?.paymentSummary.totalAppliedToDeductible && (
              <ClaimDetailsField
                label={t('payment.totalAppliedToDeductible')}
                value={claim.paymentSummary.totalAppliedToDeductible}
              />
            )}
            {claim?.paymentSummary.bloodDeductible && (
              <ClaimDetailsField
                label={t('payment.bloodDeductible')}
                value={claim.paymentSummary.bloodDeductible}
              />
            )}
            {claim?.paymentSummary.physicalTherapyCharges && (
              <ClaimDetailsField
                label={t('payment.physicalTherapyCharges')}
                value={claim.paymentSummary.physicalTherapyCharges}
              />
            )}
            {claim?.paymentSummary.psychiatricCharges && (
              <ClaimDetailsField
                label={t('payment.psychiatricCharges')}
                value={claim.paymentSummary.psychiatricCharges}
              />
            )}
            {claim?.paymentSummary.occupationalTherapyCharges && (
              <ClaimDetailsField
                label={t('payment.occupationalTherapyCharges')}
                value={claim.paymentSummary.occupationalTherapyCharges}
              />
            )}
            {claim?.paymentSummary.patientPaidToProvider && (
              <ClaimDetailsField
                label={t('payment.patientPaidToProvider')}
                value={claim.paymentSummary.patientPaidToProvider}
              />
            )}
            {claim?.paymentSummary.medicarePaidYou && (
              <ClaimDetailsField
                label={t('payment.medicarePaidYou')}
                value={claim.paymentSummary.medicarePaidYou}
              />
            )}
            {claim?.paymentSummary.medicarePaidProvider && (
              <ClaimDetailsField
                label={t('payment.medicarePaidProvider')}
                value={claim.paymentSummary.medicarePaidProvider}
              />
            )}
            {claim?.paymentSummary.cashDeductible && (
              <ClaimDetailsField
                label={t('payment.cashDeductible')}
                value={claim.paymentSummary.cashDeductible}
              />
            )}
            {claim?.paymentSummary.coInsurance && (
              <ClaimDetailsField
                label={t('payment.coInsurance')}
                value={claim.paymentSummary.coInsurance}
              />
            )}
            {claim?.paymentSummary.totalAmountYouMayBeBilled && (
              <div className='ds-u-border-top--1 ds-u-margin-top--3'>
                <ClaimDetailsField
                  label={t('payment.totalAmountYouMayBeBilled')}
                  value={claim.paymentSummary.totalAmountYouMayBeBilled}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
